import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_standard_option = _resolveComponent("standard-option");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.routerData)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: _ctx.routerData
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_standard_option, _mergeProps(_ctx.$props, {
                        "badge-count": _ctx.badgeCount,
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.goRoute(_ctx.routerData)))
                    }), null, 16, ["badge-count"])
                ]),
                _: 1
            }, 8, ["to"]))
            : (_openBlock(), _createBlock(_component_standard_option, _mergeProps({ key: 1 }, _ctx.$props, {
                "badge-count": _ctx.badgeCount,
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('click', _ctx.title)))
            }), null, 16, ["badge-count"]))
    ]));
}
